// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetDynamicFormDefinitionRequestModel from '../../model/get-dynamic-form-definition-request-model';
import GetDynamicFormDefinitionRequestDTO from '../dto/get-dynamic-form-definition-request-dto';
import dtoSchema from '../schemas/get-dynamic-form-definition-request-schema';

export default abstract class GetDynamicFormDefinitionRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetDynamicFormDefinitionRequestDTO>) {
    super();
    if (data) {
      this.appSystemKey = data.appSystemKey;
      this.id = data.id;
    }
  }
  /**
  */
  appSystemKey?: string;
  /**
  */
  id?: string;

  static toModel(dto: DeepPartial<GetDynamicFormDefinitionRequestDTO>): GetDynamicFormDefinitionRequestModel;
  static toModel(dto: DeepPartial<GetDynamicFormDefinitionRequestDTO> | undefined | null): GetDynamicFormDefinitionRequestModel | undefined;
  static toModel(dto: DeepPartial<GetDynamicFormDefinitionRequestDTO> | undefined | null): GetDynamicFormDefinitionRequestModel | undefined {
    return dto ? new GetDynamicFormDefinitionRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetDynamicFormDefinitionRequestModel> | GetDynamicFormDefinitionRequestModel): GetDynamicFormDefinitionRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      appSystemKey: unwrapped.appSystemKey,
      id: unwrapped.id,
    } as GetDynamicFormDefinitionRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetDynamicFormDefinitionRequestModel, can not map to GetDynamicFormDefinitionRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
